import { deleteSession } from '../api/atp';
const revokeAllSessions = async (logger) => {
    try {
        const response = await deleteSession(`/revokeall/lcid/{userId}`, {}, logger);
        if (response.status === 204) {
            return true;
        }
        return false;
    }
    catch (error) {
        return false;
    }
};
export default revokeAllSessions;
